import { put, takeEvery } from 'redux-saga/effects';

import {
  EXPERIENCE_DATE_FROM_CHANGE,
  EXPERIENCE_DATE_FROM_BLURRED,
  EXPERIENCE_DATE_FROM_FOCUSED,
  experienceDateFromSet,
  experienceDateFromSetFocus,
  experienceDateFromSetVisualization, experienceDateFromSetValidationMessage, experienceDateFromSetValidity
} from 'src/app/redux/actions/registration/experience/experienceDateFrom';


function* experienceDateFromFocus() {
  yield put(experienceDateFromSetFocus(true));
}


function* nativeValidation(validationMessage) {
  if (validationMessage) {
    yield put(experienceDateFromSetValidationMessage(validationMessage));
    yield put(experienceDateFromSetVisualization(true));
    return true;
  }
  return false;
}

function* isBiggerThanCurrentDate(startDate) {
  const currentDate = new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0));

  if (startDate.getTime() > currentDate.getTime()) {
    yield put(experienceDateFromSetValidationMessage('Data od nie może być większa niż obecna'));
    yield put(experienceDateFromSetVisualization(true));
    return true;
  }
  return false;
}

function* isBiggerThanEndDate(startDate, endDate, stillWorking) {
  if (startDate.getTime() && stillWorking) {
    return false;
  }

  if (startDate.getTime() > endDate.getTime()) {
    yield put(experienceDateFromSetValidationMessage('Data późniejsza niż data zakończenia'));
    yield put(experienceDateFromSetVisualization(true));
    return true;
  }

  return false;
}

function* validate(payload) {
  const { validationMessage, date, dateTo, stillWorking } = payload;

  const [startMonth, startYear] = date.split('/');
  const startDate = new Date(Date.UTC(startYear, startMonth, 0));
  const [endMonth, endYear] = dateTo.split('/');
  const endDate = new Date(Date.UTC(endYear, endMonth, 0));

  const validators = [
    nativeValidation(validationMessage),
    isBiggerThanCurrentDate(startDate),
    isBiggerThanEndDate(startDate, endDate, stillWorking)
  ];

  // eslint-disable-next-line no-restricted-syntax
  for (const validator of validators) {
    if (yield* validator) {
      return false;
    }
  }

  return true;
}

function* experienceDateFromBlur({ payload }) {
  yield put(experienceDateFromSetFocus(false));
  const valid = yield validate(payload);

  if (valid) {
    yield put(experienceDateFromSetValidationMessage(''));
    yield put(experienceDateFromSetVisualization(false));
    yield put(experienceDateFromSetValidity(true));
  } else {
    yield put(experienceDateFromSetValidity(false));
  }
}

function* experienceDateFromChange({ payload }) {
  const { value, markedAsWrong, apiError, validationMessage } = payload;
  const [month, year] = value.split('/');
  const date = value ? new Date(year, month) : null;

  yield put(experienceDateFromSet(value, date));

  if (markedAsWrong || apiError) {
    yield put(experienceDateFromSetVisualization(!!validationMessage));
  }
}


export { experienceDateFromFocus, experienceDateFromBlur, experienceDateFromChange };

export default [
  takeEvery(EXPERIENCE_DATE_FROM_CHANGE, experienceDateFromChange),
  takeEvery(EXPERIENCE_DATE_FROM_FOCUSED, experienceDateFromFocus),
  takeEvery(EXPERIENCE_DATE_FROM_BLURRED, experienceDateFromBlur)
];

